<div
  tooltip-element
  #kpiOrigin="cdkOverlayOrigin"
  cdkOverlayOrigin
  class="kpi-container"
  [ngClass]="{
    'kpi-container-hover-state': tooltipEnabled,
    'kpi-container-clicked': isSelected
  }"
  id="{{ kpiKey }}"
  role="button"
  tabindex="0"
  (click)="onKpiClick($event)"
  (mouseenter)="onKpiMouseEnter()"
  (mouseleave)="onKpiMouseLeave()"
>
  <span class="kpi-title">{{ kpi.name }}</span>
  <span class="kpi-contents">
    <span class="kpi-value">
      {{ displayValueValid ? displayValue + displayUnit : '--' }}
    </span>
    <span class="kpi-secondary-value">
      <ng-container *ngIf="displayValueValid">
        <ng-container *ngIf="displaySecondaryValue; else noSecondaryValue">
          <span>{{ displaySecondaryValue }}</span>
        </ng-container>
        <ng-template #noSecondaryValue>
          <mat-icon svgIcon="dash-medium" class="kpi-no-secondary-value-icon"></mat-icon>
        </ng-template>
      </ng-container>
    </span>
    <div class="kpi-trend-container">
      <kpi-trend-indicator
        [trendIndicator]="kpi.trendIndicator"
        [trendChange]="kpi.trendChange"
        [kpiType]="kpi.type"
        [kpiName]="kpi.name"
        [showPlaceholder]="false"
      ></kpi-trend-indicator>

      <span class="kpi-trend-text">
        {{ kpi.trendText }}
      </span>
    </div>
    <ng-container *ngIf="kpi.health as health">
      <status-badge
        [type]="'kpiHealth'"
        [badgeKey]="health"
        class="kpi-health-badge"
      ></status-badge>
    </ng-container>
  </span>
</div>

<cds-tooltip
  *ngIf="tooltipEnabled"
  [origin]="kpiOrigin"
  [open]="tooltipOpen"
  [tooltipId]="'kpi-tooltip-' + kpiKey"
  placement="top"
  [panelWidth]="280"
  [hasBackdrop]="false"
  [enableHoverDelay]="true"
  (hovered)="onTooltipHover()"
  (unhovered)="onTooltipLeave()"
>
  <ng-template #tooltipContent>
    <div class="kpi-tooltip-header">{{ kpi.name }}</div>
    <div class="kpi-tooltip-content">
      <kpi-tooltip
        [kpiName]="kpi.name"
        [kpiKey]="kpiKey"
        [keyMilestones]="keyMilestones"
      ></kpi-tooltip>
    </div>
  </ng-template>
</cds-tooltip>
